import _implicitStylesheets from "./error.css";
import _implicitScopedStylesheets from "./error.scoped.css?scoped=true";
import _axImage from "ax/image";
import _wdsButton from "wds/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div grid axis="column" class="container-text${0}"${2}><h1 type-style="display-4"${3}>${"t2"}</h1><p type-style="body-2"${3}>${"t4"}</p></div>`;
const stc0 = {
  classMap: {
    "container-inner": true
  },
  key: 0
};
const stc1 = {
  "error-img": true
};
const stc2 = {
  classMap: {
    "btn-container": true
  },
  key: 4
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind, h: api_element} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_custom_element("ax-image", _axImage, {
    classMap: stc1,
    props: {
      "width": "100%",
      "height": "100%",
      "imgSrc": $cmp.errorImage,
      "alt": $cmp.altText
    },
    key: 1
  }), api_static_fragment($fragment1, 3, [api_static_part(2, null, api_dynamic_text($cmp.errorTitle)), api_static_part(4, null, api_dynamic_text($cmp.errorDescription))]), $cmp.shouldShowButton ? api_element("div", stc2, [api_custom_element("wds-button", _wdsButton, {
    props: {
      "label": $cmp.errorButton,
      "icon": "refresh"
    },
    key: 5,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleButtonClick))
    }
  })]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3tlk8jhmpnn";
tmpl.legacyStylesheetToken = "undefined-_error";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
